export default (reviewsWidget: Ref<HTMLElement | null>) => {
  let checkInterval: ReturnType<typeof setInterval> | null = null;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const reloadWidget = () => {
    if (
      import.meta.client &&
      reviewsWidget.value &&
      typeof Trustpilot !== 'undefined' &&
      typeof Trustpilot.loadFromElement === 'function'
    ) {
      Trustpilot.loadFromElement(reviewsWidget.value, true);
    }
  };

  const waitForTrustpilot = () => {
    if (
      typeof Trustpilot !== 'undefined' &&
      typeof Trustpilot.loadFromElement === 'function'
    ) {
      reloadWidget();
    } else {
      checkInterval = setInterval(() => {
        if (
          typeof Trustpilot !== 'undefined' &&
          typeof Trustpilot.loadFromElement === 'function'
        ) {
          if (checkInterval) clearInterval(checkInterval);
          checkInterval = null;
          reloadWidget();
        }
      }, 100);

      // Clear interval after 10 seconds if Trustpilot never loads
      timeoutId = setTimeout(() => {
        if (checkInterval) clearInterval(checkInterval);
        checkInterval = null;
      }, 10000);
    }
  };

  const initializeTrustpilot = () => {
    reloadWidget();

    // Also wait for Trustpilot script to load
    if (import.meta.client) {
      const script = document.querySelector('script[src*="trustpilot.com"]');
      if (script) {
        script.addEventListener('load', reloadWidget);
      } else {
        waitForTrustpilot();
      }
    }
  };

  // Only clean up component-specific polling intervals, not the shared script
  onUnmounted(() => {
    if (checkInterval) {
      clearInterval(checkInterval);
      checkInterval = null;
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  });

  return {
    reloadWidget,
    initializeTrustpilot,
  };
};
